import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
const names = ['Camila', 'Martina', 'Sofía', 'Valentina', 'Lucía', 'Florencia', 'Agustina', 'Micaela', 'Julieta', 'Antonella'];
const cities = ['CABA', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Santa Fe', 'Neuquén'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseData, setPurchaseData] = useState({
    name: '',
    city: '',
    time: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1; // 1 to 15 mins ago
      setPurchaseData({
        name: randomName,
        city: randomCity,
        time: `${randomTime} min`
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Hide after 5 seconds
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 10000);
    // Then repeat randomly between 15 and 30 seconds
    const interval = setInterval(() => {
      if (!isVisible) {
        setTimeout(showPopup, Math.random() * 15000 + 15000);
      }
    }, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 animate-slide-up" data-id="element-126">
      <div className="bg-white text-brand-dark rounded-xl shadow-2xl p-4 pr-10 border border-zinc-200 flex items-center gap-4 max-w-sm relative" data-id="element-127">
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-zinc-400 hover:text-zinc-600" data-id="element-128">
          <X className="w-4 h-4" data-id="element-129" />
        </button>

        <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center shrink-0" data-id="element-130">
          <CheckCircle2 className="w-6 h-6 text-emerald-600" data-id="element-131" />
        </div>

        <div data-id="element-132">
          <p className="text-sm font-medium text-zinc-600" data-id="element-133">
            <span className="font-bold text-brand-dark" data-id="element-134">
              {purchaseData.name}
            </span>{' '}
            de {purchaseData.city}
          </p>
          <p className="text-xs font-bold text-brand-pink mt-0.5" data-id="element-135">
            Compró Fútbol Femenino Elite System
          </p>
          <p className="text-[10px] text-zinc-400 mt-1" data-id="element-136">
            Hace {purchaseData.time}
          </p>
        </div>
      </div>
    </div>;
}